class FeatureReview extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.modalController = null;
    }
  
    connectedCallback() {
      const swiperEl = this.querySelector('.feature-review__grid-slider');
      if (swiperEl) {
        // Initialize Swiper
        this.swiper = new Swiper(swiperEl, {
            slidesPerView: 1.2,
            spaceBetween: 24,
            breakpoints: {
              540: { slidesPerView: 2 },
              768: { slidesPerView: 2.2 },
              992: { slidesPerView: 3 }
            },
            navigation: {
                nextEl: this.querySelector(".swiper-button-next"),
                prevEl: this.querySelector(".swiper-button-prev"),
            },

            pagination: {
                el: this.querySelector(".swiper-pagination"),
                clickable: true,
            },
        });
      }

      this.initModal();
    }

    initModal() {
      const sectionRoot = this.closest('[id^="shopify-section-"]') || document;
      if (typeof window.ReviewModalController !== 'function') return;

      this.modalController = new window.ReviewModalController({
        root: sectionRoot,
        triggerSelector: '.feature-review__cta',
        modalSelector: '#featureModal',
        closeSelector: '#closeModal',
        openClass: 'is-open',
      });

      this.modalController.init();
    }
  
    disconnectedCallback() {
      if (this.modalController) {
        this.modalController.destroy();
        this.modalController = null;
      }

      if (this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
      }
    }
  }
  
  customElements.define('feature-review', FeatureReview);